import React from "react";

export const UserContext = React.createContext({});
export const QueryContext = React.createContext({});
export const MyQueriesContext = React.createContext({});
export const SharedQueriesContext = React.createContext({});
